import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "home-page"
};
const _hoisted_2 = {
  class: "home-layout"
};
const _hoisted_3 = {
  class: "hero-section"
};
const _hoisted_4 = {
  class: "hero-inner"
};
const _hoisted_5 = {
  class: "hero-actions"
};
const _hoisted_6 = {
  class: "quote-section"
};
const _hoisted_7 = {
  class: "quote-banner"
};
const _hoisted_8 = {
  class: "quote-text"
};
const _hoisted_9 = {
  class: "feature-section"
};
const _hoisted_10 = {
  class: "feature-grid"
};
import { computed } from 'vue';
import AdsterraNativeBanner from '../components/AdsterraNativeBanner.vue';
import { getDailyQuote } from '../utils/quotes.js';

// 每日名言统一数据源见 src/utils/quotes.js
// 根据天数自动切换每日名言

export default {
  __name: 'Home',
  setup(__props) {
    const dailyQuote = computed(() => getDailyQuote());

    // 展示在黄色提示条中的内容：优先展示中文部分
    const displayQuote = computed(() => (dailyQuote.value || {
      zh: ''
    }).zh);
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [_createVNode(AdsterraNativeBanner), _createElementVNode("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("h1", {
        class: "hero-title"
      }, "简洁好用的投资引擎，暴力拉升的现金游戏", -1)), _cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "hero-subtitle"
      }, " 把零散的市场信息、主观判断和交易动作，抽象成一套可复用的方法论，在复杂市场里，更稳地接近自己的长期目标。 ", -1)), _cache[3] || (_cache[3] = _createElementVNode("p", {
        class: "hero-subtitle"
      }, " 从迷信指标、迷信宏观、迷信机构成本，进化到只相信市场走势和资金安全。策略是死的，人是活的。卖飞不可怕，懂得在风险来临前空仓、保住利润才是真正的质变。 ", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
        to: "/sameboard",
        class: "btn btn-primary"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 开始使用 ", -1)]))]),
        _: 1
      })])])]), _createElementVNode("section", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "quote-dot"
      }, null, -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(displayQuote.value), 1)])]), _createElementVNode("section", _hoisted_9, [_cache[8] || (_cache[8] = _createElementVNode("h2", {
        class: "section-title"
      }, "核心功能", -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
        class: "section-subtitle"
      }, " 用一套统一的思考框架，把「市场情绪、题材风向、价格行为」串联起来。 ", -1)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_router_link, {
        to: "/sameboard",
        class: "feature-item"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "feature-icon"
        }, [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M4 17l6-6 4 4 6-7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), _createElementVNode("path", {
          d: "M14 8h6v6",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })])], -1), _createElementVNode("div", {
          class: "feature-title"
        }, "情绪雷达", -1), _createElementVNode("p", {
          class: "feature-desc"
        }, " 实时跟踪网络评论热度，快速判断市场热度。 ", -1)]))]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/investment",
        class: "feature-item"
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "feature-icon"
        }, [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), _createElementVNode("path", {
          d: "M9 7h6M9 11h6M9 15h4",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round"
        })])], -1), _createElementVNode("div", {
          class: "feature-title"
        }, "点子仓库", -1), _createElementVNode("p", {
          class: "feature-desc"
        }, " 用灵感、想法沉淀出一套的投资操作手册 ", -1)]))]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/bigfish",
        class: "feature-item"
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
          class: "feature-icon"
        }, [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M5 12v7M10 9v10M15 6v13M20 14v5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round"
        })])], -1), _createElementVNode("div", {
          class: "feature-title"
        }, "财务仪表盘", -1), _createElementVNode("p", {
          class: "feature-desc"
        }, " 聚焦基本面，快速定位当下板块龙头，辅助做出更好的仓位决策。 ", -1)]))]),
        _: 1
      })])]), _cache[10] || (_cache[10] = _createStaticVNode("<section class=\"indicator-section\" data-v-e7055cd4><h2 class=\"section-title\" data-v-e7055cd4>特色指标</h2><p class=\"section-subtitle\" data-v-e7055cd4> 把「故事」拆成可以量化和验证的维度，用更理性的方式面对不确定性。 </p><div class=\"indicator-grid\" data-v-e7055cd4><div class=\"indicator-card\" data-v-e7055cd4><div class=\"indicator-title\" data-v-e7055cd4>真情绪</div><p class=\"indicator-desc\" data-v-e7055cd4> 不只看涨跌幅，更看「上升路径」和「换手质量」，避免被末端情绪裹挟。 </p></div><div class=\"indicator-card\" data-v-e7055cd4><div class=\"indicator-title\" data-v-e7055cd4>风险安全垫</div><p class=\"indicator-desc\" data-v-e7055cd4> 结合热点强度、估值位置与基本面，把「亏多少」想清楚，再考虑「能赚多少」。 </p></div><div class=\"indicator-card\" data-v-e7055cd4><div class=\"indicator-title\" data-v-e7055cd4>持仓舒适度</div><p class=\"indicator-desc\" data-v-e7055cd4> 用波动容忍度、回撤预期和仓位管理，量化「睡得着觉」的边界。 </p></div><div class=\"indicator-card\" data-v-e7055cd4><div class=\"indicator-title\" data-v-e7055cd4>账上组合趋势</div><p class=\"indicator-desc\" data-v-e7055cd4> 聚焦「组合曲线」而非单票盈亏，让决策从「猜对一次」变成「长期可复用」。 </p></div></div></section>", 1))])]);
    };
  }
};